const API = import.meta.env.VITE_API_URL || '';

// Normalise the response envelope so callers can continue to read top-level
// fields (res.token, res.questions, res.error) regardless of whether the
// endpoint was migrated to respond_ok / respond_error yet.
//
// Enveloped success  { ok:true, token, email }   -> passed through unchanged
// Enveloped success  { ok:true, data: [...] }    -> [...] (list/scalar lift)
// Enveloped failure  { ok:false, error, fields } -> passed through unchanged
// Legacy success     { token, email }            -> passed through unchanged
// Legacy failure     { error: "..." }            -> passed through unchanged
function _unwrapEnvelope(body) {
  if (!body || typeof body !== 'object' || Array.isArray(body)) return body;
  if (body.ok === true && 'data' in body) {
    // Only lift if data is a list/scalar — dict payloads are already spread
    // at the top level by respond_ok (see backend/helpers.py).
    if (body.data === null || typeof body.data !== 'object' || Array.isArray(body.data)) {
      return body.data;
    }
  }
  return body;
}

export function api(path, opts = {}) {
  const { skipAuth, ...fetchOpts } = opts;
  const headers = {
    'Content-Type': 'application/json',
    ...(fetchOpts.headers || {}),
  };
  if (!skipAuth) {
    const token = localStorage.getItem('sqetrack_token') || '';
    headers['Authorization'] = `Bearer ${token}`;
  }
  return fetch(API + path, {
    ...fetchOpts,
    headers,
  }).then(r => {
    if (r.status === 401 && !skipAuth) {
      localStorage.removeItem('sqetrack_token');
      window.location.href = '/login';
      return {};
    }
    return r.json().then(_unwrapEnvelope);
  });
}

// Fire-and-forget event tracker — never throws
export function trackEvent(event, properties = {}) {
  api('/api/events', {
    method: 'POST',
    body: JSON.stringify({ event, properties }),
  }).catch(() => {});
}

export function downloadExport() {
  const token = localStorage.getItem('sqetrack_token') || '';
  fetch(API + '/api/export', {
    headers: { 'Authorization': `Bearer ${token}` },
  })
    .then(r => r.blob())
    .then(blob => {
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `SQE_Revision_${new Date().toISOString().slice(0, 10)}.xlsx`;
      a.click();
      URL.revokeObjectURL(url);
    });
}
